module.exports = function () {
  throw new Error('Readable.from is not available in the browser')
};



//////////////////
// WEBPACK FOOTER
// D:/cpc/sinocc.web/web.X6/www/x6.ng2/~/readable-stream/lib/internal/streams/from-browser.js
// module id = ../../../../readable-stream/lib/internal/streams/from-browser.js
// module chunks = 4